import { Drawer } from "@repo/ui/components/drawer";
import { useTranslations } from "next-intl";
import type { JSX } from "react";
import type { TriggerProps } from "@/components/types";
import { cn } from "@/lib/utils";
import { DietDetails } from "./diet-datails";

type DietDetailsProps = {
  dietId: string;
  label: JSX.Element | string;
  trigger?: TriggerProps;
  showCta?: boolean;
  configuration?: Record<string, string | number | string[]>;
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
};

export const DietDetailsDrawer = ({
  dietId,
  label,
  trigger,
  showCta,
  configuration,
  isOpen,
  onOpenChange,
}: DietDetailsProps) => {
  const t = useTranslations("diets");
  return (
    <Drawer
      trigger={{
        label: label,
        variant: "link",
        ...trigger,
        className: cn(
          "flex-1 no-underline group relative p-0  min-h-0 h-auto leading-6 whitespace-normal text-left",
          trigger?.className,
        ),
      }}
      side="left"
      cover={true}
      className="border-r-0 sm:w-1/2 sm:min-w-[640px] sm:max-w-full [&>button]:top-4 [&>button]:left-6 md:[&>button]:top-6 md:[&>button]:right-10 md:[&>button]:left-auto"
      contentClassName="p-0"
      title={t("description")}
      description={" "}
      headerClassName="md:hidden h-[60px] fixed top-0 left-0 w-full bg-white overflow-hidden sm:max-w-[640px]"
      open={isOpen}
      onOpenChange={onOpenChange}
    >
      <DietDetails
        dietId={dietId}
        share={false}
        showCta={showCta}
        configuration={configuration}
      />
    </Drawer>
  );
};
